export default __webpack_public_path__ + "static/ru-6edf42b2ab0fbc6d5a3cb68118124bb3.svg";